import { Component, OnInit } from '@angular/core';

declare function HomevoiceOnKeyPress(value, key): any;
declare function HomeresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }
  onKeyUp(event: any) {
    //debugger;    
    HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
    if (event.target.id == "endpage") {
      //$("#SkipMainContent").focus();      
    }
  };

  onkeypress(event: any) {
    //debugger;
    HomevoiceOnKeyPress(event.target.value, event.key);
  }
  ngOnInit() {
  }

}
